import { buttonOutlineDark, buttonPrimary } from '../../styles/button';
import { theme } from '../../styles/theme';

export const verifyYourEmailTitle = {
  fontWeight: 600,
  fontSize: '32px',
  color: theme.palette.common.primaryDark,
  textAlign: 'center'
};

export const verifyYourEmailButton = (
  variant: 'standard' | 'expired',
  isMobile: boolean = false
) => ({
  ...(variant === 'standard' ? buttonOutlineDark : buttonPrimary),
  px: { mobile: '30px', tablet: '40px' },
  '&[disabled]': {
    backgroundColor: theme.palette.common.lightGrey14,
    color: theme.palette.common.lightGrey8,
    paddingLeft: '48px',
    paddingRight: '48px',
    '& .MuiLoadingButton-loadingIndicator': {
      right: '16px'
    }
  },
  ...(isMobile
    ? {
        '&:hover': {
          backgroundColor: theme.palette.common.white,
          border: `1px solid ${theme.palette.common.lightGrey14}`,
          color: theme.palette.common.primaryDark
        }
      }
    : {})
});
